<template>
	<div class="operation-component">
		<div class="operation">
			<template v-if="!isFraction && (operators.checkOp_plus(operator) || operators.checkOp_minus(operator))">
				<addition-integers :floating="floating" :operator="operator" :terms="datas.terms" :estimated="estimated" :units="operation.units || units" :demo="demo" />
			</template>
			<template v-else-if="!isFraction && operators.checkOp_times(operator)">
				<multiplication :floating="floating" :fact="terms" />
			</template>
			<template v-else-if="!isFraction && operators.checkOp_div(operator)">
				<div class="d-flex">
					<!-- <division-component-french :divisor="terms[1]" :dividend="terms[0]"></division-component-french> -->
					<division-component :floating="floating" :prop-divisor="terms[1]" :prop-dividend="terms[0]" :operation-prop="operation" />
				</div>
			</template>
			<template v-else-if="!isFraction && operators.checkOp_lcm(operator)">
				<lowest-common-multiple :terms="terms" />
			</template>
			<template v-else-if="!isFraction && operators.checkOp_unknow('dvr', operator)">
				<divisibility-rules :terms="terms" />
			</template>
			<template v-else-if="!isFraction && operators.checkOp_gcf(operator)">
				<greatest-common-factor :terms="terms" />
			</template>
			<template v-else-if="!isFraction && (operators.checkOp_unknow('rti', operator) || operators.checkOp_unknow('itr', operator))">
				<div class="rti-operation">
					<roman-to-int :number="terms.shift()" />
				</div>
			</template>
			<template v-else-if="operators.checkOp_fract(operator) || operators.checkOp_unknow('fad', operator)">
				<operation-fract :fraction="terms" :operator="operator" />
			</template>
			<template v-else-if="isFraction && (operators.checkOp_unknow('max', operator) || operators.checkOp_unknow('min', operator))">
				<compare-fractions :operator="operator" :terms="terms" />
			</template>
			<template v-else-if="isFraction && operators.checkOp_unknow('rsd', operator)">
				<operation-reduce-fractions-same-denominator :terms="terms" />
			</template>
			<template v-else-if="operators.checkOp_unknow('fon', operator)">
				<operation-fraction-of-number :terms="terms" />
			</template>
			<template v-else-if="isFraction && (operators.checkOp_minus(operator) || operators.checkOp_plus(operator))">
				<operation-add-subtract-fractions :operator="operator" :terms="terms" />
			</template>
			<template v-else-if="isFraction && (operators.checkOp_times(operator) || operators.checkOp_div(operator))">
				<operation-multiplication-fractions :terms="terms" :operator="operator" />
			</template>
			<template v-else-if="fract">
				<operation-fractions :operator="operator" :terms="terms" />
			</template>
		</div>
		<div>
			<slot></slot>
		</div>
	</div>
</template>

<script type="text/javascript">
	const operators = require('../scripts/variables').operators;

	import Fraction from '../scripts/Fraction';

	import AdditionIntegers from './AdditionIntegers.vue';
	import Multiplication from './Multiplication.vue';
	import DivisionComponent from './DivisionComponent.vue';
	import LowestCommonMultiple from './LowestCommonMultiple.vue';
	import GreatestCommonFactor from './GreatestCommonFactor.vue';
	import OperationFract from './OperationFract.vue';
	import CompareFractions from './CompareFractions.vue';
	import OperationReduceFractionsSameDenominator from './OperationReduceFractionsSameDenominator.vue';
	import OperationFractionOfNumber from './OperationFractionOfNumber.vue';
	import OperationAddSubtractFractions from './OperationAddSubtractFractions.vue';
	import OperationFractions from './OperationFractions.vue';
	import OperationMultiplicationFractions from './OperationMultiplicationFractions.vue';

	import romanToInt from './romanToInt/romanToInt.vue';
	import divisibilityRules from './divisibilityRules/divisibilityRules.vue'
	import UFCT from 'usefull-functions';

	export default{
		name: 'operation',
		props: {
			datas: {
				type: Object,
				required: true,
				validator(value){
					if(!('operator' in value)){
						return false;
					}
					if(!operators.checkOp_sign(value.operator)){
						return false;
					}
					if(!('terms' in value)){
						return false;
					}
					if(operators.checkOp_div(value.operator)){
						if(typeof value.terms[1] == Number){
							return value.terms[1] > 0;
						}
					}
					if(operators.checkOp_unknow('fon',value.operator)){
						let fractions = value.terms.map(el => new Fraction(el).simplificated);
						return fractions.filterInt().length > 0;
					}

					return value.terms.length >= 1;
				}
			},
			fract: { type: Boolean, default: false },
			floating: { type: [Boolean, String, Number], required: false, default: 0 },
			estimated: { type: [Boolean, Number], required: false, default: false },
			operation: { type: [Object, String], required: false, default: () => ({operands: [], operator: ''}) },
			units: {type: String, default: ''},
			demo: {type: Boolean, default: false}
		},
		components:{
			Fraction, AdditionIntegers, Multiplication, DivisionComponent, OperationFract, CompareFractions, OperationReduceFractionsSameDenominator,
			OperationFractionOfNumber, OperationAddSubtractFractions, OperationFractions, OperationMultiplicationFractions, GreatestCommonFactor, LowestCommonMultiple,
			romanToInt, divisibilityRules
		},
		data(){
			return {
				operators: operators,
				operator: this.datas.operator,
			}
		},
		created(){;
		},
		computed:{
			terms(){
				if(Number(this.estimated) !== 0){
					return this.datas.terms.estimated();
				} else {
					return this.datas.terms;
				}
			},
			isFraction() {
				return this.fract || this.terms.some((term, i, arr) => {
					return UFCT.is_fraction(term);
				});
			}
		},
	};
</script>

<style lang="scss">
	// @import '../../styles/mixins';
	@import url('https://fonts.googleapis.com/css2?family=Comic+Neue&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,300;0,400;1,200&family=Roboto:ital,wght@0,300;0,400;1,100&display=swap');
	.operation-component{
		margin: 1rem;
		font-variant-numeric: tabular-nums;
		.litteral-operation{}
		.operation{
			font-size: 1.3em;
			.bloc-operation, .result, .block-component, .demonstration {
				// font-size: 1.5em;
				// font-family: 'Roboto Mono', monospace;
			}

			.steps {
				.step {
					list-style-image: none;
					list-style-type: disc;
					.steps {
						margin-left: 1.5rem;
						.step {
							list-style-type: square;
							/*
							position: relative;
							&:before {
								content: '';
								position: absolute;
								border-right:2px solid black;
								border-bottom:2px solid black;
								width:10px;
								// height:10px;
								top: 20px;
								left: -20px;
								transform: translateY(-50%) rotate(-45deg);
								aspect-ratio: 1;
							} */
						}

					}
					.step-demo {
						margin-left: 1.5rem;
						// font-family: 'Roboto Mono', monospace;
					}
				}
			}
		}
	}
</style>